import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=3679a564&scoped=true"
import script from "./TextBlock.vue?vue&type=script&lang=ts"
export * from "./TextBlock.vue?vue&type=script&lang=ts"
import style0 from "./TextBlock.vue?vue&type=style&index=0&id=3679a564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3679a564",
  null
  
)

export default component.exports